import pike13CancelReschedule from '../../assets/help/pike13-cancel-reschedule.png';

// Each guide renders into a section on /help and is deep-linkable via id (e.g. /help#cancel-reschedule).
// Use `image` for infographic-style guides authored by ops; use `steps` for structured guides.
// Don't AI-paraphrase ops-authored infographics — render them as-is.
const HELP_GUIDES = [
  {
    id: 'cancel-reschedule',
    category: 'Schedule',
    title: 'Cancel or reschedule a class in Pike13',
    intro: '30 seconds in Pike13 — no same-day texts needed.',
    image: {
      src: pike13CancelReschedule,
      alt: 'Step-by-step infographic for cancelling or rescheduling a class in the Pike13 app.',
    },
    author: 'Kaylah Hilliard',
  },
];

export const getHelpGuides = () => HELP_GUIDES;

export const getHelpGuide = id => HELP_GUIDES.find(g => g.id === id) || null;

export default HELP_GUIDES;
